export const linkableResourceTypes = ['flags', 'segments', 'metrics', 'ai-configs'] as const;
